import { render } from "./ModelListSelect.vue?vue&type=template&id=4989a4db&scoped=true"
import script from "./ModelListSelect.vue?vue&type=script&lang=js"
export * from "./ModelListSelect.vue?vue&type=script&lang=js"

import "./ModelListSelect.vue?vue&type=style&index=0&id=4989a4db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4989a4db"]])

export default __exports__